module.exports = __webpack_public_path__ + "img/weather_news_thumb.d57faab4.png";